import { render } from "./AppVideoPlayer.vue?vue&type=template&id=1d94829c"
import script from "./AppVideoPlayer.vue?vue&type=script&lang=js"
export * from "./AppVideoPlayer.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__